

import React, { useState } from 'react'
import { Form, Input, Button, Popover, Icon, Collapse, Divider } from 'antd'
import { ListLabelValue } from './ListLabelValue';
import style from './props.module.sass'
const { Panel } = Collapse;

interface IProps {
    json: any,
    updateOptions: (data: any, key: string) => void,
    canEdit?: boolean
}

export const DocumentColector = (props: IProps) => {

    const { canEdit = true } = props;

    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')

    const [id, setId] = useState('')
    const [category, setCategory] = useState('')
    const [minreq, setMinreq] = useState("")
    const [idErr, setIdErr] = useState('')
    const [categoryErr, setCategoryErr] = useState('')
    // const [minreqErr, setminreqErr] = useState("")
    const [options, setOptions] = useState<any>([])


    const [labelErr, setLabelErr] = useState(false)
    const [valueErr, setValueErr] = useState(false)
    const [ErrMessage, setErrMessage] = useState("")

    const [labelErrPopup, setLabelErrPopup] = useState(false)
    const [valueErrPopup, setValueErrPopup] = useState(false)

    // //editable state
    // const [edtlabel, setedtLabel] = useState('')
    // const [edtvalue, setedtValue] = useState('')

    // const [edtid, edtsetId] = useState('')
    // const [edtcategory, setedtCategory] = useState('')
    // const [edtidErr, setedtIdErr] = useState('')
    // const [edtcategoryErr, setedtCategoryErr] = useState('')
    // const [edtoptions, setedtOptions] = useState<any>([])


    // const [edtlabelErr, setedtLabelErr] = useState(false)
    // const [edtvalueErr, setedtValueErr] = useState(false)
    // const [edtErrMessage, setedtErrMessage] = useState("")

    // const [edtlabelErrPopup, setedtLabelErrPopup] = useState(false)
    // const [edtvalueErrPopup, setedtValueErrPopup] = useState(false)


    // const options: any[] = props.options;

    const checkIfPresent = (range: any[], key: any, prop: any) => {
        return range.length > 0 && range.find((option) => option[`${key}`].toLowerCase() === prop.toLowerCase())
    }

    const generateID = (key?: string) => {


        if (options.length === 0) {
            return 1
        } else {
            //Add 1 to the last option ID and return it
            return options[options.length - 1].id + 1
        }

    }

    const addOption = () => {

        const labelPresent = checkIfPresent(options, 'label', label)
        setLabelErr((!label || labelPresent) ? true : false)

        const valuePresent = checkIfPresent(options, 'value', value)
        setValueErr((!value || valuePresent) ? true : false)

        const newId = generateID()
        //Uploader limit exceeds condition
        if ((label && value) && (!labelPresent && !valuePresent) && props.json.type === "Uploader" && props.json.data.uploadLimit <= options.length) {
            // setErrMessage("Upload limit exceed!")
            setLabel('');
            setValue('')
            setValueErr(true)
            setLabelErr(true)
            setTimeout(() => {
                setValueErr(false)
                setLabelErr(false)
                setErrMessage("")
            }, 5000)
            // Only add the option if both lable and value is entered and also the entered values are not already present in options
        } else if ((label && value) && (!labelPresent && !valuePresent)) {
            setLabel('');
            setValue('')
            setErrMessage("")

            // const docsCollector = [
            //     {
            //         id: "idProofs",
            //         category: "ID Proofs",
            //         options: [
            //             { label: "Aadhar", value: "aadhar" },
            //             { label: "Driving License", value: "drivingLicense" },
            //             { label: "PAN", value: "panImg" },
            //             { label: "Passport", value: "passport" },
            //             { label: "VoterId", value: "voterId" }
            //         ],
            //         displayNameMap: {
            //             aadhar: "Aadhar",
            //             drivingLicense: "Driving License",
            //             panImg: "PAN",
            //             passport: "Passport",
            //             voterId: "Voter Id"
            //         }
            //     },
            //     {
            //         id: "salaryProofs",
            //         category: "Salary Proofs",
            //         options: [
            //             { label: "Payslip", value: "payslip" },
            //             { label: "Bank Statement", value: "bankStatement" },
            //             { label: "Single KYC Approval", value: "singleKYCApproval" }
            //         ],
            //         displayNameMap: {
            //             payslip: "Payslip",
            //             bankStatement: "Bank Statement",
            //             singleKYCApproval: "Single KYC Approval"
            //         }
            //     },
            // ]
            // props.updateOptions(docsCollector, 'data.preload.bindParams')
            // props.updateOptions([...options, { label, value, id }], 'data.options')

            setOptions([...options, { label, value, id: newId }])

        }

    }




    const popOverVisibleChange = (item: string, visible: boolean) => {
        //On mouse out
        if (!visible) {
            (item === 'label') ? setLabelErrPopup(false) : setValueErrPopup(false)
        } else {
            if (item === 'label') {
                (labelErr) ? setLabelErrPopup(true) : setLabelErrPopup(false)
            } else if (item === 'value') {
                (valueErr) ? setValueErrPopup(true) : setValueErrPopup(false)
            }
        }
    }
    const handleOnChange = (key: string) => (e: any) => {
        if (key === "setId") {
            setId(e.target.value)
            setIdErr("")
        }
        else if (key === "setcatagory") {
            setCategory(e.target.value)
            setCategoryErr("")
        } else if (key === "minreq") {

            setMinreq(e.target.value)
            // setminreqErr("")
        }
    }
    const addSection = () => {
        // const docsCollector = [
        //     {
        //         id: "idProofs",
        //         category: "ID Proofs",
        //         options: [
        //             { label: "Aadhar", value: "aadhar" },
        //             { label: "Driving License", value: "drivingLicense" },
        //             { label: "PAN", value: "panImg" },
        //             { label: "Passport", value: "passport" },
        //             { label: "VoterId", value: "voterId" }
        //         ],
        //         displayNameMap: {
        //             aadhar: "Aadhar",
        //             drivingLicense: "Driving License",
        //             panImg: "PAN",
        //             passport: "Passport",
        //             voterId: "Voter Id"
        //         }
        //     },
        //     {
        //         id: "salaryProofs",
        //         category: "Salary Proofs",
        //         options: [
        //             { label: "Payslip", value: "payslip" },
        //             { label: "Bank Statement", value: "bankStatement" },
        //             { label: "Single KYC Approval", value: "singleKYCApproval" }
        //         ],
        //         displayNameMap: {
        //             payslip: "Payslip",
        //             bankStatement: "Bank Statement",
        //             singleKYCApproval: "Single KYC Approval"
        //         }
        //     },
        // ]
        // let prevdata: any[] = props.json.data.preload.bindParams
        // let docsCollector: any = [...prevdata,]
        if (id && category && options.length !== 0
            // && minreq
        ) {

            let displayNameMap: any = {}
            let prevData: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams

            options.length > 0 && options.map((labval: any) => {
                return displayNameMap[labval.label] = labval.value

            })

            let docsCollector: any = prevData ? [...prevData, { id: id, category: category, minreq: minreq, options, displayNameMap }] : [{ id: id, category: category, minreq: minreq, options, displayNameMap }]
            props.updateOptions(docsCollector, 'data.preload.bindParams')
            setId("")
            setCategory("")
            setOptions("")
            setLabel('');
            setValue('')
            setMinreq("")

        } else {
            if (!id) {
                setIdErr("required")
            }
            if (!category) {
                setCategoryErr("required")
            }
            if (options.length === 0) {
                setErrMessage("minimum 1 option needed")
            }
            // if (!minreq) {
            //     setminreqErr("required")
            // }

        }

    }

    const handelelistoptions = (data: any, key: string, index?: number) => {
        if (index) {
            // setedtOptions(data)
            // setedtErrMessage("")
            handleListOnChange({ options: data }, index)
        } else {
            setOptions(data)
            setErrMessage("")
        }
    }

    const handleListOnChange = (data: any, index: number) => {
        let prevData: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams

        let modifiedData: any[] = prevData
        if (data.options) {

            // modifiedData[index] = { ...modifiedData[index], ...data }
        } else {

            modifiedData[index] = { ...modifiedData[index], ...data }
            props.updateOptions(modifiedData, 'data.preload.bindParams')
        }


    }
    let preloadData: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams

    return (
        <React.Fragment>
            <div style={{ justifyContent: 'space-around', alignItems: 'center' }} className={'a8-form-item props col-md-12'} >
                <Form.Item
                    validateStatus={idErr && "error"}
                    help={idErr}
                    label="Id" className={'a8-form-item props col-md-12'} style={{ marginBottom: "0px" }}>
                    <Input data-test-id="data_doc_collector_id" disabled={!canEdit} value={id} onChange={handleOnChange("setId")} placeholder="Enter Id" />
                </Form.Item>
                <Form.Item
                    validateStatus={categoryErr && "error"}
                    help={categoryErr}
                    label="Category" className={'a8-form-item props col-md-12'} style={{ marginBottom: "0px" }}>
                    <Input data-test-id="data_doc_collector_category" disabled={!canEdit} value={category} onChange={handleOnChange("setcatagory")} placeholder="large size" />
                </Form.Item>
                {/* <Form.Item
                    validateStatus={minreqErr && "error"}
                    help={minreqErr && minreqErr}
                    label="Minimum Option" className={'a8-form-item props col-md-12'} style={{ marginBottom: "0px" }}>
                    <Input value={minreq} onChange={handleOnChange("minreq")} placeholder="large size" />
                </Form.Item> */}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
                <Form.Item validateStatus={labelErr || ErrMessage ? "error" : undefined} label="Label" className={'a8-form-item props col-md-4'} >
                    <Popover
                        visible={labelErrPopup}
                        onVisibleChange={(visible) => popOverVisibleChange('label', visible)}
                        placement='topLeft'
                        trigger='hover'
                        content={(<div style={{ color: '#ff7e7a', padding: '10px' }}>{label ? 'Label exists' : 'Empty label'}</div>)}>
                        <Input
                            data-test-id="data_doc_collector_label"
                            disabled={!canEdit}
                            placeholder="Enter Label"
                            value={label}
                            onChange={(e) => {
                                setLabel(e.target.value)
                                setLabelErr(false)
                                setLabelErrPopup(false)
                                setErrMessage("")
                            }}
                            className={labelErr ? style.docsinputError : style.docsinput} />
                    </Popover>
                </Form.Item>
                <Form.Item label="Value" validateStatus={valueErr || ErrMessage ? "error" : undefined} className={'a8-form-item props col-md-4'} >
                    <Popover
                        visible={valueErrPopup}
                        onVisibleChange={(visible) => popOverVisibleChange('value', visible)}
                        placement='topLeft'
                        trigger='hover'
                        content={(<div style={{ color: '#ff7e7a', padding: '10px' }}>{value ? 'Value exists' : 'Empty value'}</div>)}>
                        <Input
                            data-test-id="data_doc_collector_value"
                            disabled={!canEdit}
                            placeholder="Enter Value"
                            value={value}
                            onChange={(e) => {
                                setValue(e.target.value)
                                setValueErr(false)
                                setValueErrPopup(false)
                                setErrMessage("")
                            }}
                            className={valueErr ? style.docsinputError : style.docsinput} />
                    </Popover>
                </Form.Item>
                {/* <Button onClick={addOption} type='default' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', fontFamily: 'muli-light', fontSize: '12px' }} className='col-md-3'> */}
                <div style={{ border: "1px solid", marginTop: "17px", background: "blue" }}>
                    <Icon
                        data-test-id="data_doc_collector_plus_icon"
                        onClick={() => canEdit && addOption()}
                        className="dynamic-delete-button"
                        style={{ padding: "3px", color: "#fff" }}
                        type="plus"
                    />
                </div>
                {/* </Button> */}

            </div>
            {ErrMessage && <div className={'a8-form-item props col-md-12'}>
                <p data-test-id="data_doc_collector_error_message" style={{ color: "red", marginLeft: "6px", marginTop: "-20px" }}>{ErrMessage}</p>
            </div>
            }
            {options.length > 0 && <div style={{ display: 'flex', flexDirection: 'column' }} className={'a8-form-item props col-md-12'}>
                {
                    options.map((option: any) => <ListLabelValue data-test-id={`${options}`} canEdit={canEdit} key={option.id} option={option} options={options} updateOptions={handelelistoptions} />)
                }
            </div>
            }
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} className="a8-form-item props col-md-12">
                <Button
                    data-test-id="data_doc_collector_add"
                    size={"large"}
                    onClick={() => canEdit && addSection()} type='default' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "10px", marginTop: '0px', fontFamily: 'Mulish', fontWeight: 300, fontSize: '12px', width: "100%", color: "white", background: "blue" }} >
                    ADD
                </Button>
            </div>
            <Divider />
            <EditableCollapse
                data-test-id="data_doc_collector_collapse"
                canEdit={canEdit}
                updateOptions={props.updateOptions}
                preloadData={preloadData}
                json={props.json}
            />
        </React.Fragment>
    )
}


interface Iprops {
    canEdit?: boolean;
    json: any
    preloadData: any,
    updateOptions: (data: any, key: string) => void
}

const EditableCollapse = (props: Iprops) => {

    //editable state
    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')

    // const [edtid, edtsetId] = useState('')
    // const [edtcategory, setedtCategory] = useState('')
    // const [edtidErr, setedtIdErr] = useState('')
    // const [edtcategoryErr, setedtCategoryErr] = useState('')
    // const [edtoptions, setedtOptions] = useState<any>([])


    const [edtlabelErr, setedtLabelErr] = useState(false)
    const [edtvalueErr, setedtValueErr] = useState(false)
    const [edtErrMessage, setedtErrMessage] = useState("")

    const [edtlabelErrPopup, setedtLabelErrPopup] = useState(false)
    const [edtvalueErrPopup, setedtValueErrPopup] = useState(false)


    const checkIfPresent = (range: any[], key: any, prop: any) => {
        return range.length > 0 && range.find((option) => option[`${key}`].toLowerCase() === prop.toLowerCase())
    }

    const generateID = (options: any) => {

        if (options.length === 0) {
            return 1
        } else {
            //Add 1 to the last option ID and return it
            return options[options.length - 1].id + 1
        }

    }

    const editAddOptions = (index: number) => {
        let prevData: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams

        const labelPresent = checkIfPresent(prevData[index].options, 'label', label)
        setedtLabelErr((!label || labelPresent) ? true : false)

        const valuePresent = checkIfPresent(prevData[index].options, 'value', value)
        setedtValueErr((!value || valuePresent) ? true : false)

        const id = generateID(prevData[index].options)
        //Uploader limit exceeds condition
        if ((label && value) && (!labelPresent && !valuePresent)) {
            setLabel('');
            setValue('')
            setedtErrMessage("")
            let data: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams
            // let modifiedData: any[] = prevData
            // setedtOptions([...edtoptions, { edtlabel, edtvalue, id }])
            handleListOnChange({ options: [...data[index].options, { label, value, id }] }, index)

        }

    }
    const handelelistoptions = (data: any, key: string, index: number) => {
        // setedtOptions(data)
        setedtErrMessage("")
        handleListOnChange({ options: data }, index)

    }

    const handleListOnChange = (data: any, index: number) => {
        let prevData: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams

        let modifiedData: any[] = prevData
        if (data.options) {
            let displayNameMap: any = {}
            let { options } = data
            options.length > 0 && options.map((labval: any) => {
                return displayNameMap[labval.label] = labval.value

            })

            modifiedData[index] = { ...modifiedData[index], ...data, displayNameMap }
        } else {

            modifiedData[index] = { ...modifiedData[index], ...data }
        }

        props.updateOptions(modifiedData, 'data.preload.bindParams')

    }

    const popOverVisibleChange = (item: string, visible: boolean) => {
        //On mouse out
        if (!visible) {
            (item === 'label') ? setedtLabelErrPopup(false) : setedtValueErrPopup(false)
        } else {
            if (item === 'label') {
                (edtlabelErr) ? setedtLabelErrPopup(true) : setedtLabelErrPopup(false)
            } else if (item === 'value') {
                (edtvalueErr) ? setedtValueErrPopup(true) : setedtValueErrPopup(false)
            }
        }
    }

    const genExtra = (index: number) => (
        <Icon
            data-test-id="delete"
            type="delete"
            onClick={event => {
                event.stopPropagation();
                let prevData: any[] = props.json.data && props.json.data.preload && props.json.data.preload.bindParams
                let modifiedData: any[] = prevData
                modifiedData.splice(index, 1);
                props.updateOptions(modifiedData, 'data.preload.bindParams')

            }}
        />
    );
    let {
        canEdit = true,
        preloadData,
    } = props
    return (
        <Collapse bordered={false} defaultActiveKey={['1']}
            accordion
            // style={{ background: "white" }}

            expandIcon={(panel: any) => panel.isActive ? <Icon type="minus" /> : <Icon type="plus" />}
            expandIconPosition="left"

        >
            {preloadData && preloadData.map((docs: any, index: number) => {
                return (
                    <Panel
                        data-test-id={`Section ${index + 1}`}
                        header={
                            `Section ${index + 1}`
                        } key={index + 1} extra={genExtra(index)}>
                        <div style={{ justifyContent: 'space-around', alignItems: 'center' }} className={'a8-form-item props col-md-12'} >
                            <Form.Item
                                validateStatus={docs.id === "" ? "error" : undefined}
                                help={docs.id === "" && "id should not be empty"}
                                label="Id" className={'a8-form-item props col-md-12'} style={{ marginBottom: "0px" }}>
                                <Input data-test-id="data_doc_collector_id" disabled={!canEdit} value={docs.id} onChange={(e) => { handleListOnChange({ id: e.target.value }, index) }} placeholder="Enter Id" />
                            </Form.Item>
                            <Form.Item
                                validateStatus={docs.category === "" ? "error" : undefined}
                                help={docs.category === "" && "category should not be empty"}
                                label="Category" className={'a8-form-item props col-md-12'} style={{ marginBottom: "0px" }}>
                                <Input data-test-id="data_doc_collector_category" disabled={!canEdit} value={docs.category} onChange={(e) => { handleListOnChange({ category: e.target.value }, index) }} placeholder="large size" />
                            </Form.Item>
                            {/* <Form.Item
                                validateStatus={docs.minreq === "" ? "error" : undefined}
                                help={docs.minreq === "" && "mimium Option should not be empty"}
                                label="Minimum Option" className={'a8-form-item props col-md-12'} style={{ marginBottom: "0px" }}>
                                <Input value={docs.minreq} onChange={(e) => { handleListOnChange({ minreq: e.target.value }, index) }} placeholder="large size" />
                            </Form.Item> */}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
                            <Form.Item validateStatus={edtlabelErr || edtErrMessage ? "error" : undefined} label="Label" className={'a8-form-item props col-md-4'} >
                                <Popover
                                    visible={edtlabelErrPopup}
                                    onVisibleChange={(visible) => popOverVisibleChange('label', visible)}
                                    placement='topLeft'
                                    trigger='hover'
                                    content={(<div style={{ color: '#ff7e7a', padding: '10px' }}>{label ? 'Label exists' : 'Empty label'}</div>)}>
                                    <Input
                                        data-test-id="data_doc_collector_label"
                                        disabled={!canEdit}
                                        placeholder="Enter Label"
                                        value={label}
                                        onChange={(e) => {
                                            setLabel(e.target.value)
                                            setedtLabelErr(false)
                                            setedtLabelErrPopup(false)
                                            setedtErrMessage("")
                                        }}
                                        className={edtlabelErr ? style.docsinputError : style.docsinput} />
                                </Popover>
                            </Form.Item>
                            <Form.Item label="Value" validateStatus={edtvalueErr || edtErrMessage ? "error" : undefined} className={'a8-form-item props col-md-4'} >
                                <Popover
                                    visible={edtvalueErrPopup}
                                    onVisibleChange={(visible) => popOverVisibleChange('value', visible)}
                                    placement='topLeft'
                                    trigger='hover'
                                    content={(<div style={{ color: '#ff7e7a', padding: '10px' }}>{value ? 'Value exists' : 'Empty value'}</div>)}>
                                    <Input
                                        data-test-id="data_doc_collector_value"
                                        disabled={!canEdit}
                                        placeholder="Enter Value"
                                        value={value}
                                        onChange={(e) => {
                                            setValue(e.target.value)
                                            setedtValueErr(false)
                                            setedtValueErrPopup(false)
                                            setedtErrMessage("")
                                        }}
                                        className={edtvalueErr ? style.docsinputError : style.docsinput} />
                                </Popover>
                            </Form.Item>

                            <div style={{ border: "1px solid", marginTop: "17px", background: "blue" }}>
                                <Icon
                                    data-test-id="data_doc_collector_plus_icon"
                                    onClick={() => canEdit && editAddOptions(index)}
                                    className="dynamic-delete-button"
                                    style={{ padding: "3px", color: "#fff" }}
                                    type="plus"
                                />
                            </div>


                        </div>
                        {docs.options.length === 0 && <div className={'a8-form-item props col-md-12'}>
                            <p data-test-id="data_doc_collector_error_message" style={{ color: "red", marginLeft: "6px", marginTop: "-20px" }}>minimum 1 option needed</p>
                        </div>
                        }
                        {docs.options.length > 0 && <div style={{ display: 'flex', flexDirection: 'column' }} className={'a8-form-item props col-md-12'}>
                            {
                                docs.options.map((option: any) => <ListLabelValue data-test-id={`${docs.options}`} canEdit={canEdit} key={option.id} option={option} options={docs.options} updateOptions={(data: any, updatekeys: string) => handelelistoptions(data, updatekeys, index)} />)
                            }
                        </div>
                        }
                    </Panel>
                )
            })}
        </Collapse>

    )
}









